// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M12 20.75a7.81 7.81 0 0 0 3.125-.625 8.065 8.065 0 0 0 2.537-1.712 8.07 8.07 0 0 0 1.713-2.538A7.81 7.81 0 0 0 20 12.75h-1c0 1.95-.68 3.604-2.038 4.962C15.604 19.071 13.95 19.75 12 19.75c-1.95 0-3.604-.68-4.962-2.038C5.679 16.354 5 14.7 5 12.75c0-1.95.68-3.604 2.038-4.963C8.396 6.429 10.05 5.75 12 5.75h.375L10.75 7.375l.7.725 2.85-2.875-2.875-2.85-.7.7 1.65 1.675H12a7.81 7.81 0 0 0-3.125.625 8.077 8.077 0 0 0-2.538 1.712 8.077 8.077 0 0 0-1.712 2.538A7.81 7.81 0 0 0 4 12.75a7.81 7.81 0 0 0 .625 3.125 8.077 8.077 0 0 0 1.712 2.538 8.077 8.077 0 0 0 2.538 1.712A7.809 7.809 0 0 0 12 20.75z" />
    </Icons>
  );
}
